import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card } from "reactstrap";
import AmazonProductListingFieldRow from "./AmazonProductListingFieldRow";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing_v1/FetchAllAssetsAsinWiseService";

import AssetsgalleryImges from "./AssetsGalleryImges";
import { connect } from "react-redux";
import CustomModal from "../../../../Components/Modals/CustomModal";
import VariationsChildGrid from "./VariationsChildGrid";

function AmazonProductListingGroupSection(props) {
  const [galleryImg, setGalleryImg] = useState();
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);
  const [slectedImgReplace, setSelectedReplace] = useState([]);

  const variationTheme = useMemo(() => {
    const sourceFields = props.allFields || props.fields || [];
    const themeField = sourceFields.find(f => f.field === "variation_theme");

    if (!themeField) return null;

    // Priority 1: normalized_value
    let val = themeField.normalized_value;

    // Priority 2: listing.value (seller-specific)
    if (!val) {
      val = themeField.listing && themeField.listing.value;
    }

    // Priority 3: catalog.value (Array(1) → first element)
    if (!val) {
      val = themeField.catalog && themeField.catalog.value;
    }

    // e.g. [{value: "COLOR"}] → "COLOR"  OR  ["COLOR"] → "COLOR"
    if (Array.isArray(val)) {
      const first = val[0];
      if (first && typeof first === "object" && first.value !== undefined) {
        return first.value || null;   // [{value: "COLOR"}] case
      }
      return first || null;           // ["COLOR"] case
    }

    if (val && typeof val === "object" && val.value !== undefined) {
      return val.value || null;
    }

    return val || null;
  }, [props.allFields, props.fields]);

  useEffect(() => {
    let data = {
      asin: props.selectedAsin

    };
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        setGalleryImg(res.fileList);
      }
    });
  }, []);
  const handleAction = (value) => {
    console.log(value)
    setSelectedReplace(value)
    setImagePopUpOPen(true)
  };


  const handleChange = () => {

    if (props.onFieldChange) {

      props.onFieldChange({
        field: slectedImgReplace.field,
        value: selectedImages.filePath
      });
    }

    setImagePopUpOPen(false);
  };


  if (!props.fields || props.fields.length === 0) return null;

  const renderGridContent = () => (
    <div className="group-section-body">
      <Row className="g-2 px-3 py-2 border-bottom align-items-center m-0 group-section-col-headers"
        style={{
          position: "sticky",
          top: "243px",
          zIndex: 99,
        }}>
        <Col md={2}>Field</Col>
        <Col md={3}>Catalog</Col>
        <Col md={3}>Listing</Col>
        <Col md={4}>Edit</Col>
      </Row>

      <div className="group-section-scroll-container">
        {props.fields.map((f, i) => (
          <AmazonProductListingFieldRow 
            key={f && f.field ? f.field : i} 
            field={f} 
            action={handleAction}
            onFieldChange={props.onFieldChange}
            changedFields={props.changedFields}
            readOnly={props.title === "Variations"} 
          />
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className="group-section-container">
        
        {props.title === "Variations" ? (
          <Card className="card-of-problemarea p-3 mb-4 shadow-sm border-0">
            {renderGridContent()}
          </Card>
        ) : (
          renderGridContent()
        )}

        <div> 
          {props.title === "Variations" && (
            <VariationsChildGrid
              token={props.token}
              selectedAsin={props.selectedAsin}
              sku={props.sku}
              prefetchedVariationTheme={variationTheme}
              schemaFields={props.allFields} 
            />
          )}
        </div>
      </div>

      <CustomModal
        header={"Select Image"}
        isOpen={imagePopUpOPen}
        toggle={() => setImagePopUpOPen(!imagePopUpOPen)}
        size={"xl"}
        className='curve-popup'
      >
        {/* <Card className='card-of-problemarea p-2'> */}
        <AssetsgalleryImges galleryImg={galleryImg}
          setGalleryImg={setGalleryImg}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
          handleSubmitFile={handleChange} />
        {/* </Card> */}
      </CustomModal>

    </>
  );
}

var mapStateToProps = function (state) {
  return { token: state.loggedUser.token };
};

export default connect(mapStateToProps)(AmazonProductListingGroupSection);